/**
 * Add reserved ability to a model
 */

import { RESERVED, SEATRADIUS, RENDERER_MODE, SEATSTATUS, CHANNEL } from '@/constants';

import SVG from 'svg.js';
import Application from '../application';

export interface ReservableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
}

export const ReservableMixin = <T extends { new (...args: any[]): ReservableRequirements }>(base: T) => {
  return class ReservableMixin extends base {
    reservedShape: SVG.Path | null = null;

    get reserved() {
      return this.attributes.status === SEATSTATUS.RESERVED;
    }

    set reserved(value) {
      this.attributes.status = value ? SEATSTATUS.RESERVED : SEATSTATUS.FREE;
      this.toggleReservedIconVisibility();
    }

    toggleReservedIconVisibility() {
      if (this.reserved) {
        this.initReservedShape();
      } else {
        this.removeReservedShape();
      }
    }

    initReservedShape([cx, cy]: number[] = this.attributes.position) {
      if (this.reservedShape?.node || (RENDERER_MODE && this.app.props.channel === CHANNEL.WEB)) return;

      const size = (SEATRADIUS - 2) * this.app.seatmap.scale;

      this.reservedShape = this.view
        .path(RESERVED.SHAPE)
        .size(size)
        .center(cx, cy)
        .stroke(RESERVED.STROKE)
        .fill('none');
    }

    removeReservedShape() {
      this.reservedShape && this.reservedShape.remove();
      this.reservedShape = null;
    }

    updateReservedShape(x: number, y: number) {
      if (this.reservedShape) {
        const size = (SEATRADIUS - 2) * this.app.seatmap.scale;
        this.reservedShape.size(size).center(x, y);
      }
    }
  };
};
